import React from "react";

const MedicineDetailsModal = ({ open, onClose, medicine }) => {
  if (!open) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const totalValue = medicine
    ? (medicine.quantity_in_stock * medicine.price).toLocaleString("en-PK", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "0.00";

  const fields = medicine
    ? [
        { label: "Medicine Name", value: medicine.medicine_name },
        { label: "Quantity in Stock", value: medicine.quantity_in_stock },
        { label: "Price per Unit", value: `Rs. ${medicine.price}` },
        { label: "Total Value", value: `Rs. ${totalValue}`, highlight: true },
        { label: "Expiry Date", value: formatDate(medicine.expiry_date) },
        { label: "Supplier", value: medicine.supplier_name || "—" },
      ]
    : [];

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-[420px] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Header ── */}
        <div className="bg-[#1F2937] px-5 py-4 flex items-center justify-between flex-shrink-0">
          <div>
            <p className="text-[10px] font-medium uppercase tracking-widest text-gray-400">
              Inventory
            </p>
            <p className="text-white font-semibold text-sm leading-tight mt-0.5">
              Medicine Details
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-8 h-8 rounded-full
              bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white
              transition-all duration-200 text-lg font-bold leading-none"
          >
            &times;
          </button>
        </div>

        {/* ── Avatar Strip ── */}
        {medicine && (
          <div className="bg-gray-50 border-b border-gray-100 px-5 py-3 flex items-center gap-3 flex-shrink-0">
            <div className="w-10 h-10 rounded-full bg-[#1F2937] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
              {medicine.medicine_name?.charAt(0)?.toUpperCase() || "M"}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-gray-800 truncate">
                {medicine.medicine_name}
              </p>
              <p className="text-[11px] text-gray-400 truncate">
                {medicine.supplier_name || "No supplier"}
              </p>
            </div>
            <span
              className={`text-[10px] font-semibold px-2.5 py-1 rounded-full border whitespace-nowrap flex-shrink-0 ${
                medicine.quantity_in_stock > 10
                  ? "bg-emerald-50 text-emerald-600 border-emerald-100"
                  : "bg-red-50 text-red-500 border-red-100"
              }`}
            >
              {medicine.quantity_in_stock > 10 ? "In Stock" : "Low Stock"}
            </span>
          </div>
        )}

        {/* ── Fields ── */}
        <div className="flex-1 px-5 py-3 divide-y divide-gray-100">
          {medicine ? (
            fields.map(({ label, value, highlight }) => (
              <div
                key={label}
                className="flex items-center justify-between py-2.5"
              >
                <span className="text-[11px] font-bold uppercase tracking-widest text-gray-400 w-36 flex-shrink-0">
                  {label}
                </span>
                <span
                  className={`text-[13px] font-semibold text-right tabular-nums ${
                    highlight ? "text-[#F07F1C]" : "text-gray-700"
                  }`}
                >
                  {value}
                </span>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-400 text-sm py-6">
              No details available.
            </p>
          )}
        </div>

        {/* ── Footer ── */}
        <div className="border-t border-gray-100 bg-gray-50 px-5 py-3 flex justify-end flex-shrink-0">
          <button
            onClick={onClose}
            className="text-[11px] font-semibold px-4 py-1.5 rounded-lg bg-[#1F2937] text-white
              hover:bg-gray-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MedicineDetailsModal;
